export default __webpack_public_path__ + "static/team-25-designing-the-future-header-076aa9a287c272d2aa4e10ad443c63df1372834fe1570aa92ba429c5aac7f5fa.png";